/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_DailyInputs */

const en_admin_external_booking_edit_daily = /** @type {(inputs: Admin_External_Booking_Edit_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily`)
};

const de_admin_external_booking_edit_daily = /** @type {(inputs: Admin_External_Booking_Edit_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täglich`)
};

const es_admin_external_booking_edit_daily = /** @type {(inputs: Admin_External_Booking_Edit_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diario`)
};

const fr_admin_external_booking_edit_daily = /** @type {(inputs: Admin_External_Booking_Edit_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journalier`)
};

const nl_admin_external_booking_edit_daily = /** @type {(inputs: Admin_External_Booking_Edit_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dagelijks`)
};

/** @type {(inputs: Admin_External_Booking_Edit_DailyInputs) => LocalizedString} */
const it_admin_external_booking_edit_daily = en_admin_external_booking_edit_daily;

/** @type {(inputs: Admin_External_Booking_Edit_DailyInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_daily = en_admin_external_booking_edit_daily;

/** @type {(inputs: Admin_External_Booking_Edit_DailyInputs) => LocalizedString} */
const pl_admin_external_booking_edit_daily = en_admin_external_booking_edit_daily;

/** @type {(inputs: Admin_External_Booking_Edit_DailyInputs) => LocalizedString} */
const hu_admin_external_booking_edit_daily = en_admin_external_booking_edit_daily;

/** @type {(inputs: Admin_External_Booking_Edit_DailyInputs) => LocalizedString} */
const ro_admin_external_booking_edit_daily = en_admin_external_booking_edit_daily;

/**
* | output |
* | --- |
* | "Daily" |
*
* @param {Admin_External_Booking_Edit_DailyInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_daily = /** @type {((inputs?: Admin_External_Booking_Edit_DailyInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_DailyInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_daily(inputs)
	if (locale === "de") return de_admin_external_booking_edit_daily(inputs)
	if (locale === "es") return es_admin_external_booking_edit_daily(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_daily(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_daily(inputs)
	if (locale === "it") return it_admin_external_booking_edit_daily(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_daily(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_daily(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_daily(inputs)
	return ro_admin_external_booking_edit_daily(inputs)
});
export { admin_external_booking_edit_daily as "admin.external_booking_edit.daily" }